import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPenaltyMethod.ts
var t = () => e("penaltyMethod");
//#endregion
export { t as useTrPenaltyMethod };
